import { z } from 'zod';

import type {
  CreateEmployeePayProfileRequest,
  CreateEmployeePayProfileResponse,
  DeleteEmployeePayProfileRequest,
  DeleteEmployeePayProfileResponse,
  EmployeePayProfileDto,
  ListEmployeePayProfilesRequest,
  ListEmployeePayProfilesResponse,
  UpdateEmployeePayProfileRequest,
  UpdateEmployeePayProfileResponse,
} from './employee-pay-profiles.dto.js';

const timestampSchema = z.iso.datetime();
const dateSchema = z.iso.date();
const hourlyRateSchema = z.number().nonnegative();
const notesSchema = z.string().trim().min(1);

export const EmployeePayProfileDtoSchema: z.ZodType<EmployeePayProfileDto> = z.object({
  id: z.uuid(),
  companyId: z.uuid(),
  employeeId: z.uuid(),
  effectiveFrom: dateSchema,
  effectiveTo: dateSchema.nullable(),
  hourlyRate: hourlyRateSchema.nullable(),
  notes: notesSchema.nullable(),
  createdAt: timestampSchema,
  updatedAt: timestampSchema,
});

export const ListEmployeePayProfilesRequestSchema: z.ZodType<ListEmployeePayProfilesRequest> = z.object({
  companyId: z.uuid(),
  employeeId: z.uuid(),
});

export const ListEmployeePayProfilesResponseSchema: z.ZodType<ListEmployeePayProfilesResponse> = z.object({
  items: z.array(EmployeePayProfileDtoSchema),
});

export const CreateEmployeePayProfileRequestSchema: z.ZodType<CreateEmployeePayProfileRequest> = z.object({
  companyId: z.uuid(),
  employeeId: z.uuid(),
  effectiveFrom: dateSchema,
  effectiveTo: dateSchema.nullable().optional(),
  hourlyRate: hourlyRateSchema.nullable().optional(),
  notes: notesSchema.nullable().optional(),
});

export const CreateEmployeePayProfileResponseSchema: z.ZodType<CreateEmployeePayProfileResponse> = z.object({
  payProfile: EmployeePayProfileDtoSchema,
});

export const UpdateEmployeePayProfileRequestSchema: z.ZodType<UpdateEmployeePayProfileRequest> = z.object({
  companyId: z.uuid(),
  employeeId: z.uuid(),
  payProfileId: z.uuid(),
  effectiveFrom: dateSchema.optional(),
  effectiveTo: dateSchema.nullable().optional(),
  hourlyRate: hourlyRateSchema.nullable().optional(),
  notes: notesSchema.nullable().optional(),
});

export const UpdateEmployeePayProfileResponseSchema: z.ZodType<UpdateEmployeePayProfileResponse> = z.object({
  payProfile: EmployeePayProfileDtoSchema,
});

export const DeleteEmployeePayProfileRequestSchema: z.ZodType<DeleteEmployeePayProfileRequest> = z.object({
  companyId: z.uuid(),
  employeeId: z.uuid(),
  payProfileId: z.uuid(),
});

export const DeleteEmployeePayProfileResponseSchema: z.ZodType<DeleteEmployeePayProfileResponse> = z.object({
  payProfileId: z.uuid(),
});
